import {GROUPS} from "../../../utils/constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

export const GroupBadge = ({ groupName }) => {
  const groupData = GROUPS.find(g =>
    g.name === groupName || g.path === groupName
  );
  return groupData ? (
    <span
      className={`px-2 py-1 rounded-lg text-sm text-nowrap ${groupData.color}`}
    >
      <FontAwesomeIcon icon={groupData.icon} className={"mr-2"}/>
      {groupData.shortName}
    </span>
  ) : null;
}
